import { LogIn } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'

import { loginRedirect } from '@/lib/auth'

export default function Login() {
  const [params] = useSearchParams()
  const denied = params.get('error') === 'access_denied'

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="pop-in w-[360px] rounded-lg border border-line bg-pane p-6">
        <div className="font-mono text-[13px] font-medium">
          vulpio<span className="text-primary">/</span><span className="text-text-2">admin</span>
        </div>
        <h1 className="mt-5 text-[18px] font-semibold text-foreground">Sign in</h1>
        <p className="mt-1.5 text-[13px] leading-relaxed text-text-2">
          Admin console for the vulpio organisation on Jira Cloud. Sign in with your Atlassian account to continue.
        </p>
        {denied && (
          <p role="alert" className="mt-4 rounded-md border border-danger px-3 py-2 text-[12.5px] text-danger">
            Access denied — your account isn’t on the admin allowlist. Contact an org admin.
          </p>
        )}
        <button
          type="button"
          onClick={loginRedirect}
          className="mt-5 flex h-9 w-full items-center justify-center gap-2 rounded-md bg-primary text-[13px] font-semibold text-accent-fg transition-[filter,box-shadow] hover:shadow-[0_0_0_3px_color-mix(in_oklab,var(--primary)_30%,transparent)] hover:brightness-110 active:brightness-95"
        >
          <LogIn aria-hidden className="size-4" />
          Log in with Atlassian
        </button>
        <p className="mt-4 font-mono text-[11px] text-text-3">vulpio-mcp · Jira Cloud</p>
      </div>
    </main>
  )
}
